'use strict';

var d3 = require('d3');
var _ = require('lodash');
var XAxisCircles = function XAxisCircles(constants) {
  return function (seasonOverridePropertyName, fillPropertyName, opacityPropertyName, orient) {
    var params, scales;
    var mode = orient || constants.AXIS.MODE.BOTTOM;
    var circles = function circles(container) {
      var xAxisGroup = container.select('.x-axis-' + mode).selectAll('.tick');
      var groups = container.select('.groups').selectAll('.stack.visible');
      xAxisGroup.each(function (d) {
        var preAxisData = _.findLast(groups.data(), function (e) {
          return e.d1 === d;
        });
        if (preAxisData && preAxisData[seasonOverridePropertyName] !== undefined) {
          d3.select(this).selectAll('circle').remove();
          d3.select(this).insert('circle', 'text').attr({
            'cx': 0,
            'cy': 14,
            'fill': preAxisData[fillPropertyName],
            'opacity': preAxisData[opacityPropertyName],
            'r': 10
          });
        }
      });
    };
    circles.params = function (value) {
      params = value;
      return circles;
    };
    circles.scales = function (value) {
      scales = value;
      return circles;
    };
    return circles;
  };
};
XAxisCircles.$inject = ['ChartElementsConstants'];
module.exports = XAxisCircles;